<template>
  <div class="about-page">
    <!-- 头部导航组件 -->
    <HeaderNav />

    <!-- 统一的顶部装饰和图片 -->
    <div class="box_1-spacer flex-col"></div>
    <div class="box_2 flex-col"></div>
    <div class="banner-wrapper">
      <img class="banner-img" :src="getImageUrl(siteConfig?.config?.['pic_关于我们']) || '/files/images/M2.jpg'" alt="About Banner" referrerpolicy="no-referrer" />
    </div>

    <!-- Section 1: Introduction (公司介绍) -->
    <div class="section-intro container">
      <!-- Left Side: Title Group -->
      <div class="intro-left">
        <!-- <div class="title-group">
          <div class="title-en">COMPANY PROFILE</div>
          <div class="title-sep"></div>
          <div class="title-cn">公司介绍</div>
        </div> -->
         <div class="online-left">
           <div class="online-en">CEMETERY PROFILE</div>
           <div class="online-sep"></div>
           <div class="online-cn">陵园介绍</div>
        </div>
        <img class="intro-deco-img" src="./assets/img/0723a036582961a6f83f80d36917e199.png" alt="Deco" />
      </div>
      <!-- Right Side: Content with Background -->
      <div class="intro-right-wrapper">
        <div class="intro-right">
          <div class="intro-header">
            <img class="intro-icon" src="./assets/img/9e899d7ce675d01c87931ce9c12caf6b.png" alt="Icon" />
            <h2 class="intro-title-cn">常山陵园</h2>
          </div>
          <div class="intro-content">
            <div class="intro-text"
              v-html="processCompanyDesc(siteConfig?.config?.company_desc || '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位于石家庄市学府路（原五七路）121号，省军区农场北侧的常山陵园，占地245亩，地势平坦，海拔76.8米。始建于94年底，系河北省民政厅批准兴建并颁发（墓证字第12号）经营许可证的合法经营性公墓，为正定县民政局下属事业单位。<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;陵园首期开发一百二十亩，分四十个区。碑石采用优质天然石材，融南北风格为一体。陵园安葬形式主要以墓穴安葬为主，节地生态安葬为辅。墓碑坐北面南，符合民风，顺乎民意。将故人安葬于此，是您理想的选择。')">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Section 2: Culture (陵园文化) -->
    <div class="section-culture">
      <div class="culture-container container">
        <div class="section-header">
          <div class="header-main">
            <img class="header-deco left" src="./assets/img/b5ab3c1e061c0bf1f0a4f27363886802.png" alt="deco" />
            <h2 class="header-title">陵园文化</h2>
            <img class="header-deco right" src="./assets/img/009391fde4d831b0e71a048752f490fc.png" alt="deco" />
          </div>
          <div class="header-sub">CEMETERY CULTURE</div>
        </div>

        <div class="culture-grid">
          <!-- Card 1 -->
          <div class="culture-card">
            <div class="card-header">
              <img class="card-icon" src="./assets/img/14e4ea954a368a3fde7650480f19739d.png" alt="Icon" />
              <div class="card-titles">
                <div class="card-title-cn">陵园的服务理念</div>
                <div class="card-title-en">Cemetery Service Philosophy</div>
              </div>
            </div>
            <div class="card-sep"></div>
            <div class="card-desc">逝者是朋友，故人当亲人。</div>
          </div>

          <!-- Card 2 -->
          <div class="culture-card">
            <div class="card-header">
              <img class="card-icon" src="./assets/img/1c42e9ad86ee7a95a7840121990def1f.png" alt="Icon" />
              <div class="card-titles">
                <div class="card-title-cn">经营理念</div>
                <div class="card-title-en">Business Philosophy</div>
              </div>
            </div>
            <div class="card-sep"></div>
            <div class="card-desc">勤、信、智、诚。遵守法律法规，保证逝属权益，是我们的经营准则。</div>
          </div>

          <!-- Card 3 -->
          <div class="culture-card">
            <div class="card-header">
              <img class="card-icon" src="./assets/img/5287678034ee8f4dc5deac9616188ec0.png" alt="Icon" />
              <div class="card-titles">
                <div class="card-title-cn">我们的目标</div>
                <div class="card-title-en">Our goal</div>
              </div>
            </div>
            <div class="card-sep"></div>
            <div class="card-desc">集百家公墓之精华，树常山陵园之特色，创国家一流公墓，建真情永恒的人生后花园。</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Section 3: Contact Info (联系方式) -->
      <div class="contact-slogan">以专业的速度和温暖的解决方案</div>
    <div class="section-contact-info container">
      
      <div class="contact-box-left">
        <iframe 
          src="https://koh30.shangyundian.cn/wa.html" 
          frameborder="0" 
          class="map-iframe"
          title="地图"
          allowfullscreen
        ></iframe>
      </div>
      <div class="contact-box-right">
        <div class="contact-header">
          <div class="contact-header-en">CONTACT INFORMATION</div>
          <div class="contact-header-sep"></div>
          <div class="contact-header-cn">联系方式</div>
        </div>

        <div class="contact-details">
          <div class="contact-item">
            <span class="label">客服热线</span>
            <span class="value highlight">{{ siteConfig?.config?.tel || '400-000-0000' }}</span>
          </div>
          <div class="contact-item">
            <span class="label">业务咨询</span>
            <span class="value">{{ siteConfig?.config?.fax || '123456789' }}</span>
          </div>
          <div class="contact-item">
            <span class="label">Email</span>
            <span class="value">{{ siteConfig?.config?.email || '123456789@hotmail.com' }}</span>
          </div>
          <div class="contact-item">
            <span class="label">公司地址</span>
            <span class="value">{{ siteConfig?.config?.addr || '上海市嘉定区嘉松北路3485号 伊宁路2688号（国际赛车场西侧）' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer: ContactUsSection -->
    <ContactUsSection />
  </div>
</template>

<script>
import HeaderNav from '@/components/HeaderNav.vue';
import ContactUsSection from '@/components/ContactUsSection.vue';
import { getSiteConfig } from '@/api/home';
import { getImageUrl } from '@/config/api';


export default {
  name: 'AboutUsPage',
  components: {
    HeaderNav,
    ContactUsSection
  },
  data() {
    return {
      siteConfig: null
    };
  },
  created() {
    this.fetchSiteConfig();
  },
  methods: {
    async fetchSiteConfig() {
      try {
        const res = await getSiteConfig();
        if (res.code === 0 && res.data && res.data.config) {
          this.siteConfig = res.data;
        } else {
          // Toast.fail(res.msg || '获取网站配置失败');
        }
      } catch (error) {
        console.error('获取网站配置失败:', error);
      }
    },
    getImageUrl(imgPath) {
      return getImageUrl(imgPath);
    },
    // 处理公司描述，修复图片路径
    processCompanyDesc(html) {
      if (!html) return '';
      // 将相对路径的图片URL转换为完整URL
      return html.replace(/<img([^>]*?)src=["']([^"']+)["']([^>]*?)>/gi, (match, before, src, after) => {
        // 如果src已经是完整URL，直接返回
        if (src.startsWith('http://') || src.startsWith('https://')) {
          return match;
        }
        // 如果是相对路径，转换为完整URL
        const fullUrl = getImageUrl(src);
        return `<img${before}src="${fullUrl}"${after}>`;
      });
    }
  }
};
</script>

<style scoped>
/* Global Container */
.about-page {
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
  overflow-x: hidden;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

/* 
   Section: Banner 
*/
.box_1-spacer {
  background-color: rgba(255, 255, 255, 1) !important;
  width: 100% !important;
  max-width: 1920px !important;
  height: auto !important;
  min-height: 100px !important;
  margin: 0 auto !important;
  box-sizing: border-box !important;
}

.box_2 {
  background-color: rgba(0, 149, 151, 1) !important;
  width: 100% !important;
  max-width: 36px !important;
  height: 4px !important;
  margin: 50px auto 0 !important;
  box-sizing: border-box !important;
}

.banner-wrapper {
  width: 100% !important;
  max-width: 1918px !important;
  height: auto !important;
  min-height: 398px !important;
  margin: -53px auto 0 !important;
  overflow: hidden !important;
  box-sizing: border-box !important;
}

.banner-img {
  width: 100% !important;
  max-width: 1918px !important;
  height: auto !important;
  min-height: 398px !important;
  margin: 0 auto !important;
  display: block !important;
  object-fit: cover !important;
  box-sizing: border-box !important;
}

/* 
   Section: Intro (公司介绍)
*/
.section-intro {
  display: flex;
  margin-top: 60px;
  margin-bottom: 60px;
  gap: 40px;
  align-items: center;
}
.online-left {
  display: flex;
  /* flex-direction: column; */
  /* flex: 1; */
  align-items: center;
}

.online-en {
  font-size: 30px;
  color: #999;
  letter-spacing: 2px;
      writing-mode: vertical-rl;
    text-orientation: mixed ;
    letter-spacing: 3px ;
    color: rgba(92, 92, 92, 1) !important
}

.online-sep {
  width: 2px;
  height: 40px;
  background: #8c3000;
  margin: 10px 22px;
   writing-mode: vertical-rl;
    text-orientation: mixed ;
    letter-spacing: 3px ;
}

.online-cn {
  font-size: 40px;
  color: #333;
  font-family: STKaitiSC-Black;
  font-weight: 500;
   writing-mode: vertical-rl;
    text-orientation: mixed ;
    letter-spacing: 3px ;
    color: rgba(0, 0, 0, 1) !important;
    font-size: 40px !important;
    font-family: KaiTi, 楷体, STKaiti, STKaitiSC-Regular !important;
    font-weight: normal !important;
}
.intro-left {
  flex: 0 0 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

.title-en {
  font-family: BookmanOldStyle;
  font-size: 16px;
  color: #5c5c5c;
  letter-spacing: 1px;
}

.title-sep {
  width: 2px;
  height: 60px;
  background-color: #956d53;
  margin: 15px 0;
}

.title-cn {
  font-size: 40px;
  font-family: STKaitiSC-Bold;
  font-weight: bold;
  color: #333;
  writing-mode: vertical-rl;
  letter-spacing: 5px;
}

.intro-deco-img {
  width: 100%;
  max-width: 280px;
  object-fit: contain;
}

.intro-right-wrapper {
  flex: 1;
  display: flex;
  gap: 40px;
  align-items: center;
  position: relative;
  min-height: 450px;
  border-radius: 4px;
  padding: 20px;
  box-sizing: border-box;
}

.intro-right {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}

.intro-header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
  position: relative;
}

.intro-icon {
  width: 60px;
  height: auto;
}

.intro-title-cn {
  font-size: 32px;
  font-family: STKaitiSC-Black;
  color: #333;
  margin: 0;
  position: relative;
}

.intro-content {
  background-color: transparent;
  color: #333;
  padding: 20px 40px 40px 40px;
  border-radius: 4px;
  position: relative;
}

.intro-text {
  font-size: 14px;
  line-height: 1.8;
  text-align: justify;
}

.intro-text .paragraph_1 {
  margin-top: 10px !important;
}

.intro-text img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 10px auto;
  border-radius: 4px;
}

.intro-text p {
  margin: 10px 0;
}

/* 
   Section: Culture (陵园文化)
*/
.section-culture {
  background: url(./assets/img/fedd0943c80d5a6ebbc75a8cf2ee8d11.png) no-repeat right center;
  background-size: contain;
  background-color: #f9f9f9;
  padding: 60px 0;
  position: relative;
}

.section-header {
  text-align: center;
  margin-bottom: 50px;
}

.header-main {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 10px;
}

.header-deco {
  width: 50px;
  height: auto;
}

.header-title {
  font-family: STKaitiSC-Bold;
  font-size: 36px;
  color: #8c3000;
  margin: 0;
}

.header-sub {
  font-family: Arial;
  font-size: 14px;
  color: #999;
  letter-spacing: 2px;
  text-align: center;
}

.culture-grid {
  display: flex;
  justify-content: center;
  gap: 30px;
  flex-wrap: wrap;
}

.culture-card {
  flex: 1;
  min-width: 300px;
  max-width: 380px;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 30px;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  transition: transfrom 0.3s;
}

.culture-card:hover {
  transform: translateY(-5px);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
}

.card-icon {
  width: 50px;
  height: 50px;
  object-fit: contain;
}

.card-titles {
  display: flex;
  flex-direction: column;
}

.card-title-cn {
  font-size: 20px;
  font-family: STKaitiSC-Bold;
  color: #8c3000;
  margin-bottom: 5px;
}

.card-title-en {
  font-size: 12px;
  color: #999;
}

.card-sep {
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, #956d53 0%, rgba(255, 255, 255, 0) 100%);
  margin-bottom: 20px;
}

.card-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

/* 
   Section: Contact Info (联系方式)
*/
.section-contact-info {
  display: flex;
  margin: 80px auto;
  gap: 40px;
  align-items: center;
}

.contact-box-left {
  /* flex: 1; */
  /* min-height: 300px; */
  width: 70%;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
}

.map-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
  border-radius: 4px;
}


.contact-slogan {
  /* position: absolute; */
  /* top: 40px;
  left: 40px; */
  font-family: STKaitiSC-Black;
  font-size: 18px;
  color: #8c3000;
  max-width: 300px;
  margin: 0 auto;
  margin-top: 60px;
}

.contact-box-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.contact-header {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.contact-header-en {
  font-size: 14px;
  color: #999;
}

.contact-header-sep {
  flex: 1;
  height: 1px;
  background-color: #ccc;
  margin: 0 15px;
}

.contact-header-cn {
  font-size: 24px;
  color: #333;
  font-family: STKaitiSC-Black;
}

.contact-details {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.contact-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.contact-item .label {
  font-size: 14px;
  color: #999;
}

.contact-item .value {
  font-size: 16px;
  color: #333;
}

.contact-item .value.highlight {
  font-size: 24px;
  color: #8c3000;
  font-weight: bold;
}

/* 
   Responsive Mobile 
*/
@media (max-width: 768px) {
  .box_1-spacer {
    min-height: 80px !important;
  }

  .box_2 {
    margin: 30px auto 0 !important;
  }

  .banner-wrapper {
    margin: -40px auto 0 !important;
    min-height: 300px !important;
  }

  .banner-img {
    min-height: 300px !important;
  }

  .contact-box-left {
  /* flex: 1; */
  /* min-height: 300px; */
  width: 100%;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
}
  .online-sep {
  width: 40px;
  height: 2px;
  background: #8c3000;
  margin: 10px 0;
   writing-mode: vertical-rl;
    text-orientation: mixed ;
    letter-spacing: 3px ;
}
  .online-en ,.online-sep, .online-cn{
  font-size: 14px;
  color: #999;
  letter-spacing: 2px;
  writing-mode: horizontal-tb !important;
  /* 覆盖 text-orientation 为默认值 */
  text-orientation: upright !important;
  /* 覆盖 letter-spacing 为默认值 0 */
  letter-spacing: 0 !important;
}
  /* Intro */
  .section-intro {
    flex-direction: column;
    margin-top: 30px;
  }
 .online-left {
    align-items: center;
     display: flex;
  flex-direction: column;
  }
  .intro-left {
    flex: auto;
    width: 100%;
    flex-direction: column;
    /* Keep column to stack elements centered */
    justify-content: center;
    gap: 20px;
  }
.banner-wrapper {
  width: 100%;
  max-width: 1920px;
  height: 158px;
  margin: 0 auto;
  box-sizing: border-box;
  overflow: hidden;
}

.banner-img {
  width: 100%;
  max-width: 100%;
  height: auto;
  min-height: 158px;
  margin: 0 auto;
  display: block;
  object-fit: cover;
  box-sizing: border-box;
}
  .title-group {
    margin: 0;
    align-items: center;
  }

  .title-cn {
    writing-mode: horizontal-tb;
    /* Switch to horizontal */
    font-size: 32px;
    /* Slightly smaller for mobile */
    letter-spacing: 2px;
  }

  .title-sep {
    width: 40px;
    /* Horizontal line */
    height: 2px;
    margin: 10px 0;
  }

  .intro-deco-img {
    height: auto;
    width: 60%;
    max-width: 200px;
  }

  .intro-header {
    justify-content: center;
  }

  .intro-content {
    padding: 20px;
  }

  /* Culture */
  .header-title {
    font-size: 28px;
  }

  .header-deco {
    width: 30px;
  }

  .culture-grid {
    flex-direction: column;
    align-items: center;
  }

  .culture-card {
    width: 100%;
    max-width: none;
  }

  /* Contact Info */
  .section-contact-info {
    flex-direction: column;
    margin: 40px auto;
  }

  .contact-box-left {
    min-height: 200px;
  }

  .contact-slogan {
    font-size: 20px;
    top: 20px;
    left: 20px;
  }

  .contact-header {
    flex-direction: column-reverse;
    gap: 10px;
    text-align: center;
  }

  .contact-header-sep {
    display: none;
  }

  .contact-details {
    text-align: center;
  }
}
</style>
